<template>
    <div class="stickers-layout">
        <layout-header
            type="stickers"
            class="all-info"
        />
        <div class="container">
            <slot></slot>
        </div>
        <layout-footer />
    </div>
</template>

<script>
    import LayoutHeader from '@/components/user/layouts/header';
    import LayoutFooter from '@/components/user/layouts/footer';

    export default {
        name: 'stickers-layout',
        components: {
            LayoutHeader,
            LayoutFooter,
        },
    };
</script>

<style scoped lang="scss">
    .container{
        width: to_rem(1490px);
        margin: 0 auto;
    }
    @include mobile_or_P{
        .container{
            width: 100%;
            padding-top: 5rem;
        }
    }
    @include mobile_or_P{
        .container{
            padding-top: 5rem;
        }
    }
</style>
